import LayoutPaystub from './LayoutPaystub'

export default LayoutPaystub
